<template>
  <div class="card-item">
    <v-tooltip left color="surface_neutral_selected">
      <template v-slot:activator="{ on, attrs }">
        <div
          class="card-item__drag"
          role="button"
          tabindex="0"
          aria-label="Arraste para mover este item"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="text_secondary">mdi-drag</v-icon>
        </div>
      </template>
      <span>Segure e arraste para a coluna de exibição</span>
    </v-tooltip>

    <div v-if="item.url_capa" class="card-item__media" @click="showModalImagem">
      <img :src="item.url_capa" alt="Capa Notícia" />
    </div>

    <div class="card-item__body">
      <div class="card-item__title" style="font-weight: 600">{{ item.dsc_titulo_resumido }}</div>
      <div v-if="item.dsc_subtitulo" class="card-item__info">{{ item.dsc_subtitulo }}</div>
      <div class="card-item__meta">
        <span class="meta-source">{{ portalDisplayName(item.cod_portal) }}</span>
        <span class="meta-separator">&bull;</span>
        <span>{{ formatDate(item.dat_modificacao_noticia) }}</span>
        <span class="meta-separator">&bull;</span>
        <span>{{ formatHour(item.dat_modificacao_noticia) }}</span>
      </div>
    </div>

    <div class="card-item__actions">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--edit"
            v-bind="attrs"
            v-on="on"
            @click="adicionarNoticia"
           role="button" aria-label="Enviar para Coluna exibição">
            <v-icon>mdi-arrow-right</v-icon>
          </div>
        </template>
        <span>Enviar para Coluna exibição</span>
      </v-tooltip>

      <ModalRemoverDaPasta :noticia="item" v-if="cod_pasta" />

      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--favorite"
            :class="{ 'is-bursting': bursting }"
            role="button"
            :aria-label="item.flg_favorita ? 'Desfavoritar notícia' : 'Favoritar notícia'"
            v-bind="attrs"
            v-on="on"
            @click.prevent="handleFavoritarClick"
          >
            <v-icon v-if="!item.flg_favorita && !bursting">mdi-heart-outline</v-icon>
            <v-icon v-else>mdi-heart</v-icon>
            <span v-for="i in 5" :key="`hp-${i}`" :class="`heart-particle heart-particle--${i}`" aria-hidden="true">♥</span>
          </div>
        </template>
        <span>{{ item.flg_favorita ? "Desfavoritar notícia" : "Favoritar notícia" }}</span>
      </v-tooltip>

      <ModalEnviarColaboracaoOuNoticiaParaPasta
        v-if="!cod_pasta"
        :cod_noticia="item.cod_noticia"
        :isNoticia="true"
        :cod_producao="cod_producao"
        :type="1"
        action-variant="card-action-box--edit"
      />
    </div>

    <ModalImagem
      :dialog="isModalImagemAprovadasVisible"
      @close="closeModalImagem"
      :midia_url="item.url_capa"
    />
  </div>
</template>

<script>
import ModalRemoverDaPasta from "@/components/Modal/Colaboracao/ModalRemoverDaPasta.vue";
import ModalImagem from "@/components/Modal/ModalImagem.vue";
import ModalEnviarColaboracaoOuNoticiaParaPasta from "@/components/Modal/Pastas/ModalEnviarColaboracaoOuNoticiaParaPasta.vue";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import { mapGetters } from "vuex";
export default {
  props: {
    item: Object,
    getNoticiasAprovadas: Function,
    getNoticiasModeradas: Function,
    currentPage: Number,
    isFavoritaTab: Boolean,
  },
  components: {
    ModalImagem,
    ModalEnviarColaboracaoOuNoticiaParaPasta,
    ModalRemoverDaPasta,
  },

  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      bursting: false,
    };
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    cod_producao() {
      return this.$store.state.producoes.selectedProducao.cod_producao;
    },
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
      portalDisplayName: "portais/getPortalDisplayName",
    }),
  },
  methods: {
    formatDate,
    formatHour,
    async showModalImagem(midia_url_aprovadas) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("text/plain", JSON.stringify(item));
    },
    async adicionarNoticia() {
      const formData = {
        cod_noticia: this.item.cod_noticia,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        cod_portal: this.item.cod_portal,
        dsc_titulo_resumido: this.item.dsc_titulo_resumido,
      };

      await apiClient
        .post("/noticiasModeradas/inserirNoticiaModerada", formData)
        .then(async () => {
          await this.getNoticiasModeradas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            page: this.$store.state.noticias.noticiasModeradas.currentPage,
            size: 5,
            filtro_texto: this.$store.state.noticias.filtro_moderadas,
          });
          await this.getNoticiasAprovadas({
            cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            page: this.currentPage,
            size: 5,
            flg_favorita: this.$store.state.noticias.flg_favorita,
            filtro_texto: this.$store.state.noticias.filtro_aprovadas,
            cod_pasta: this.cod_pasta,
            cod_editoria: this.$store.state.portais.selectedEditoria,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    handleFavoritarClick() {
      // Heart-burst flourish only when un-favorited → favorited.
      if (!this.item.flg_favorita) {
        this.bursting = true;
        setTimeout(() => { this.bursting = false; }, 900);
      }
      this.favoritarNoticia();
    },

    async favoritarNoticia() {
      const cod_portal = this.$store.state.portais.selectedPortal.cod_portal;
      const cod_producao = this.$store.state.producoes.selectedProducao.cod_producao;
      const cod_noticia = this.item.cod_noticia;
      if (!this.item.flg_favorita) {
        await apiClient
          .post("noticias/setNoticiaFavorita", {
            cod_portal,
            cod_producao,
            cod_noticia,
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.getNoticiasAprovadas({
              cod_portal: cod_portal,
              cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
              flg_favorita: this.isFavoritaTab,
              page: this.currentPage,
              size: 5,
              filtro_texto: this.$store.state.noticias.filtro_aprovadas,
              cod_pasta: this.cod_pasta,
              cod_editoria: this.$store.state.portais.selectedEditoria,
            });
          });
      } else {
        await apiClient
          .delete(
            `noticias/removeNoticiaFavorita/${cod_noticia}/${cod_portal}/${cod_producao}`
          )
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.getNoticiasAprovadas({
              cod_portal: cod_portal,
              cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
              flg_favorita: this.$store.state.noticias.flg_favorita,
              page: this.currentPage,
              size: 5,
              filtro_texto: this.$store.state.noticias.filtro_aprovadas,
              cod_pasta: this.cod_pasta,
              cod_editoria: this.$store.state.portais.selectedEditoria,
            });
          });
      }
    },
  },
};
</script>
